import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { COVER_TYPE_IMAGE } from '../../constants/cover-types';
import PageCover from '../page-cover';
import classNames from 'classnames';
import Link from '../../components/link/internal-link';
import Button from '../../components/button';
import { TEXT_ALIGNMENT_CLASS_NAMES } from '../../constants/text-alignment';
import MoreButton from '../../components/more-button';
import CategoryActions from '../../containers/category-actions';
import withTranslate from '../../hoc/with-translate';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import withCategoryTextAlignment from '../../hoc/with-category-text-alignment';
import withAuth from '../../hoc/with-auth';
import styles from './category-list-item-masonry.scss';

const COVER_WIDTH = 455;
const COVER_HEIGHT = 265;

const CategoryListItemMasonry = props => {
  const {
    category,
    t,
    borderWidth,
    titleFontClassName,
    contentFontClassName,
    categoryTextAlignment,
    isAuthenticated,
  } = props;
  const textAlignmentClassName = styles[TEXT_ALIGNMENT_CLASS_NAMES[categoryTextAlignment]];
  const hasCover = category.coverType === COVER_TYPE_IMAGE;
  const className = classNames(
    styles.container,
    'forum-card-background-color',
    'forum-card-border-color',
    'category-list-item',
    {
      [styles.hasCover]: hasCover,
      [textAlignmentClassName]: textAlignmentClassName,
    }
  );
  const categoryLink = `/${category.slug}`;
  let categoryActions;

  if (isAuthenticated) {
    categoryActions = (
      <div className={styles.actions}>
        <MoreButton>
          <CategoryActions category={category}/>
        </MoreButton>
      </div>
    );
  }
  return (
    <div className={className} style={{ borderWidth }} data-hook="category-list-item">
      <Link
        className={classNames(styles.link, 'forum-text-color')}
        to={categoryLink}
        renderInSeo={false}
        data-hook="category-list-item__link"
      >
        <div className={styles.cover}>
          <PageCover
            cover={category.cover}
            coverType={category.coverType}
            backgroundColor={category.backgroundColor}
            width={COVER_WIDTH}
            height={COVER_HEIGHT}
          />
        </div>
        <div className={styles.contentWrapper}>
          {categoryActions}
          <div className={classNames(styles.content, contentFontClassName)}>
            <div className={titleFontClassName}>
              <h2 name={category.label} className={styles.title} data-hook="category-list-item__title">
                <object type="communities/link">
                  <Link to={categoryLink} style={{ color: 'inherit' }}>
                    {category.label}
                  </Link>
                </object>
              </h2>
            </div>
            <p className={styles.statistics} data-hook="category-list-item__statistics">
              {t('category-list-item.total-views', { count: category.totalViews || 0 })}
              {' | '}
              {t('category-list-item.total-posts', { count: category.totalPosts || 0 })}
            </p>
            <p className={styles.description} data-hook="category-list-item__description">
              {category.description}
            </p>
            <p className={styles.button}>
              <Button data-hook="category-list-item__view-category">
                {t('category-list-item.view-category')}
              </Button>
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

CategoryListItemMasonry.propTypes = {
  category: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  borderWidth: PropTypes.number,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  categoryTextAlignment: PropTypes.number.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

export default flowRight(
  withAuth,
  withCardBorderWidth,
  withCategoryTextAlignment,
  withFontClassName,
  withTranslate
)(CategoryListItemMasonry);



// WEBPACK FOOTER //
// ./app/components/category-list-item-masonry/category-list-item-masonry.js